"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.query = exports.getRelativeURL = exports.getRelativeUrl = void 0;
const constants_1 = require("@/app/shared/constants");
const getRelativeUrl = (input) => {
    if (input === null)
        return location.href;
    const urlString = input.toString();
    const isPath = urlString.startsWith('/');
    const isHash = urlString.startsWith('#');
    if (isPath || isHash) {
        const url = new URL(location.href);
        if (isHash) {
            url.hash = urlString;
        }
        else {
            const cleanInput = isPath ? urlString.slice(1) : urlString;
            url.pathname = `${url.pathname.replace(/\/$/, '')}/${cleanInput}`;
        }
        return url.toString();
    }
    return urlString;
};
exports.getRelativeUrl = getRelativeUrl;
const getRelativeURL = (url) => new URL((0, exports.getRelativeUrl)(url));
exports.getRelativeURL = getRelativeURL;
exports.query = {
    set(url, queries, options = constants_1.DEFAULT_OPTIONS.query.set) {
        const defaultOptions = constants_1.DEFAULT_OPTIONS.query.set;
        const Options = { ...defaultOptions, ...options };
        const urlObj = (0, exports.getRelativeURL)(url);
        for (const [key, value] of new URLSearchParams(queries).entries()) {
            if (!Options.setUndefined && value === 'undefined') {
                continue;
            }
            urlObj.searchParams.append(key, value);
        }
        return urlObj.toString();
    },
    add(url, queries) {
        const urlObj = (0, exports.getRelativeURL)(url);
        for (const [key, value] of new URLSearchParams(queries).entries()) {
            urlObj.searchParams.append(key, value);
        }
        return urlObj.toString();
    },
    update(url, queries) {
        const urlObj = (0, exports.getRelativeURL)(url);
        for (const [key, value] of new URLSearchParams(queries).entries()) {
            urlObj.searchParams.set(key, value);
        }
        return urlObj.toString();
    },
    remove(url, queryKeys) {
        const urlObj = (0, exports.getRelativeURL)(url);
        for (const queryKey of queryKeys) {
            urlObj.searchParams.delete(queryKey);
        }
        return urlObj.toString();
    },
    clear(url) {
        const urlObj = (0, exports.getRelativeURL)(url);
        urlObj.search = '';
        return urlObj.toString();
    },
    toString(queries) {
        return new URLSearchParams(queries).toString();
    },
    fromString(url) {
        const urlObj = (0, exports.getRelativeURL)(url);
        return Object.fromEntries(urlObj.searchParams.entries());
    },
};
